module.exports = __webpack_public_path__ + "static/media/stenobothrus_nigromaculatus_mehrere_s_M_012_APA.26186048.png";